<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.products')} / ${$t('menu.hotels')}`"
      >
        <Hotels></Hotels>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import Hotels from './tablas/Hotels.vue'

export default {
  components: {
    AppCardCode,
    Hotels,
  },
}
</script>
